import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCurrentReviewer } from 'query/reviewer';
import type { Reviewer } from 'types/DataExtraction';

type useCurrentReviewerReturnType = {
  currentReviewer?: Reviewer;
  isLoading?: boolean;
  isError?: boolean;
  error?: any;
};
export function useCurrentReviewer(
  onError?: (error: any) => any
): useCurrentReviewerReturnType {
  const { isError, isLoading, error, data: currentReviewer } = useQuery({
    queryKey: ['currentReviewer'],
    queryFn: getCurrentReviewer,
    staleTime: 300_000, // 5 minutes
  });

  useEffect(() => {
    if (onError && isError) {
      onError(error);
    }
  }, [isError, error, onError]);

  return {
    currentReviewer,
    isLoading,
    isError,
    error,
  };
}
